'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import { domAnimation, LazyMotion, m, } from 'motion/react';
import { Children, cloneElement, isValidElement, useMemo, useRef, } from 'react';
import { ConditionalWrapper } from '../../index.js';
import { Elevator } from '../elevator/index.js';
import styles from './tooltip.module.css';
export const Tooltip = ({ children, className, trigger, side = 'top', sideOffset = 4, align = 'center', alignOffset, delayDuration, usePortal = false, ...otherProps }) => {
    const triggerRef = useRef();
    const computeOrigin = useMemo(() => {
        if (side === 'left') {
            return { x: 20, y: 0 };
        }
        if (side === 'right') {
            return { x: -20, y: 0 };
        }
        if (side === 'top') {
            return { x: 0, y: 20 };
        }
        return { x: 0, y: -20 };
    }, [side]);
    const animation = useMemo(() => ({
        hidden: {
            opacity: 0,
            ...computeOrigin,
        },
        visible: {
            opacity: 1,
            y: 0,
            x: 0,
        },
    }), [computeOrigin]);
    return (_jsxs(TooltipPrimitive.Root, { delayDuration: delayDuration, ...otherProps, children: [Children.map(trigger, child => isValidElement(child) && (_jsx(TooltipPrimitive.Trigger, { asChild: true, children: cloneElement(child, {
                    ref: triggerRef,
                    tabIndex: 0,
                }) }))), _jsx(LazyMotion, { features: domAnimation, children: _jsx(Elevator, { resting: 3, children: _jsx(ConditionalWrapper, { condition: usePortal, wrapper: children => _jsx(TooltipPrimitive.Portal, { children: children }), children: _jsx(TooltipPrimitive.Content, { asChild: true, side: side, align: align, sideOffset: sideOffset, alignOffset: alignOffset, className: clsx(styles.Tooltip, className), children: _jsxs(m.div, { initial: "hidden", animate: "visible", exit: "hidden", variants: animation, transition: {
                                    type: 'spring',
                                    stiffness: 700,
                                    damping: 30,
                                }, children: [children, _jsx(TooltipPrimitive.Arrow, { fill: "var(--global-foreground)", className: styles.Arrow })] }) }) }) }) })] }));
};
export const TooltipProvider = TooltipPrimitive.Provider;
